import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { TokenData } from '~~/interfaces/token'
import { onSnapshot } from "firebase/firestore";
import { FirestoreCollections } from '~~/interfaces/database/FirestoreCollections'
import { useBootstrapStore } from './bootstrap';
import { useTableStore } from './table';

const TOKEN = 'token'

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => {
    return {
      token  : null as unknown as TokenData,
      viewAs: 'guest', // guest only (employee flow removed in V3 migration)
      guest: null,
    }
  },
  actions: {
    async init(){
      await this.checkToken()    
    },

    checkToken() {
      return new Promise((resolve, reject) => {
        try {
          let router = useRouter();
    
          const tokenCookie = this.getTokenFromCookie();
          if (tokenCookie) {
            this.token = tokenCookie;
          } else {
            const _token = useStorage('token', {});
            this.token = _token.value;
          }
    
          if (this.token.storeId === undefined) {
            router.push('/login');
            //reject('Token is invalid, redirected to login');
            console.log('Token is invalid, redirected to login');
            return;
          }
    
          this.viewAs = this.token.type;
    
          // Set Table Selected
          const useTable = useTableStore();
          useTable.table = this.token.table;
    
          // Set StoreId 
          const _firebaseRefInstance = useFirebaseXtable();
          _firebaseRefInstance.setStoreId(this.token.storeId);
    
          const _firestore = useFirestoreXtable();
          _firestore.setStoreId(this.token.storeId);
    
          resolve('Token is valid');
        } catch (error) {
          reject(`Error occurred: ${error}`);
        }
      });
    },
    watchRealtimeTokenExpired(){
      let ref = useFirestoreXtable().collectionDocIdRef(FirestoreCollections.QRCODES, this.token.qrcodeId)
        onSnapshot(ref, (doc) => {    
            if (!doc.exists()) {                    
                this.clearToken()
            }else {                     
                this.token = doc.data()   
            }
        })
    },

    getTokenFromCookie(){
      const cookieData = getCookie("xtable_order") || null          
      if(cookieData){
        const parsedData = JSON.parse(cookieData)
        return parsedData.token       
      }
      return null
    },    

    clearToken(){        
      removeCookie("xtable_order", ".xtable.co", true)
      const t = useStorage('token', {})
      t.value = null
      this.token = null
 
      //Clear app state
      const useBootstrap = useBootstrapStore()
      useBootstrap.loaded = false
      
      useRouter().push('/login')
    },
    
    logout () {
      removeCookie("xtable_order", ".xtable.co", true)
      let token = useStorage('token', { })
      token.value = null

      this.clearToken()
    }
  },

  getters: {}
})